module.exports = __webpack_public_path__ + "img/rings.48663717.svg";